// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.solved-stories-container {
  background-color: rgb(199, 231, 199);
  display: flex;
  flex-direction: column;
  animation: test 5s;
  overflow: scroll;
  width: 100%;
}
.solved-stories-container.should-flex {
flex:1 1;
}`, "",{"version":3,"sources":["webpack://./src/Components/Games/Newsie/UploadContentNewsie/NewsiePreview/SolvedStoriesContainer/SolvedStoriesContainer.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;AACA;AACA,QAAM;AACN","sourcesContent":[".solved-stories-container {\n  background-color: rgb(199, 231, 199);\n  display: flex;\n  flex-direction: column;\n  animation: test 5s;\n  overflow: scroll;\n  width: 100%;\n}\n.solved-stories-container.should-flex {\nflex:1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
